import { Injectable } from '@angular/core';
import { RedirectUrlSettingService } from '@rd/core/services/redirect-url-setting/redirect-url-setting.service';

@Injectable({
  providedIn: 'root',
})
export class AnzRedirectUrlSettingService extends RedirectUrlSettingService {
  // For ANZ we must change the locationPathName to /select-card
  // cause we have a bug that cause user with multiple cards to
  // redirect to homepage instead of /select-card cause when we
  // click the login button on homepage RD will use Hermes to save
  // the current application state including redirectUrl which is "/"
  // so when we navigate back from GH we will use this redirectUrl
  // to navigate and cause this error
  // Ref: https://kaligo.atlassian.net/browse/BUG-989
  getLoginRedirectUrl(): string {
    return window.location.pathname === '/'
      ? '/select-card'
      : window.location.pathname;
  }
}
